import React__default from 'react';
import { FeatureIcon } from '@grandvisionhq/icons';

const getFeatures = Object.keys;
const SolutionsFeatures = (props)=>{
    if (Object.values(props).every((feature)=>!feature.variantHasAttribute
    )) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("ul", {
        className: "product-detail-solutions-features"
    }, getFeatures(props).map((feature, i)=>{
        var ref;
        return ((ref = props[feature]) === null || ref === void 0 ? void 0 : ref.variantHasAttribute) && /*#__PURE__*/ React__default.createElement("li", {
            className: "product-detail-solutions-features__feature product-detail-solutions-features__feature--basics",
            key: feature
        }, /*#__PURE__*/ React__default.createElement(FeatureIcon, {
            name: feature,
            color: 'grey',
            size: 38
        }), props[feature].label);
    }));
};
var SolutionsFeatures$1 = SolutionsFeatures;

export { SolutionsFeatures$1 as default };
//# sourceMappingURL=SolutionsFeatures.js.map
